import ListCheck from '@/icons/list-check.svg';

function DetailItem({ title, description }) {
	if (!title && !description) {
		return null;
	}

	return (
		<div className="flex items-start gap-2 [&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:text-green">
			<ListCheck />
			<div className="flex flex-col gap-1">
				{title && <p className="text-xs font-semibold">{title}</p>}

				{description && (
					<p className="text-xs text-grey-500">{description}</p>
				)}
			</div>
		</div>
	);
}

export default DetailItem;
